import * as React from 'react';
import * as styles from '../dashboards.module.scss';
import { PaginatedDashboardContext } from '../../../../../shared/paginated-dashboard-context';
import Scrollbars from 'react-custom-scrollbars';
import Entry from './dashboard-entry';
import Dashboard from '../../../../../models/dashboard';
import Table from '../../../../table/table';
import TableHead from '../../../../table/table-head';
import HeaderCell from '../../../../table/table-header-cell';
import TableBody from '../../../../table/table-body';
import usePaginatedDashboards from '../../../../../hooks/usePaginatedDashboards';
import { DashboardSortingOptions } from '../../../../../models/enums/adminSortingOptions';

interface Props {
  clientId: number;
  loading: boolean;
}

const DashboardTable = ({ clientId, loading }: Props) => {
  const { results, pageSize, orderColumn, orderDirection, searchTerm } = React.useContext(PaginatedDashboardContext);
  const { fetchDashboards } = usePaginatedDashboards();
  const reorderHandler = (orderColumn: string, orderDirection: 'asc' | 'desc') => {
    fetchDashboards({ clientId, currentPage: 1, pageSize, searchTerm, orderColumn, orderDirection });
  };

  return (
    <div className={styles.tableWrapper}>
      <div style={{ height: '90%' }}>
        <Scrollbars className={styles.scrollTable} autoHide={true} universal={true}>
          <Table loading={loading} results={results}>
            <TableHead>
              <HeaderCell
                title="Name"
                scope="col"
                orderField={DashboardSortingOptions.Name}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Description"
                scope="col"
                orderField={DashboardSortingOptions.Description}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell title="Tags" scope="col" />
              <HeaderCell
                title="Report ID"
                scope="col"
                orderField={DashboardSortingOptions.ReportId}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell
                title="Status"
                scope="col"
                orderField={DashboardSortingOptions.Status}
                orderColumn={orderColumn}
                orderDirection={orderDirection}
                reorderHandler={reorderHandler}
              />
              <HeaderCell title="" />
            </TableHead>
            <TableBody>
              {!results || results.length === 0 ? (
                <tr>
                  <td>There are no dashboards.</td>
                </tr>
              ) : (
                results.map((results: Dashboard, index: number) => {
                  return <Entry key={results.reportId} clientId={clientId} dashboard={results} />;
                })
              )}
            </TableBody>
          </Table>
        </Scrollbars>
      </div>
    </div>
  );
};

export default DashboardTable;
